import axios from 'axios';
import { baseURL } from '../config';

const BASE_URL = `${baseURL}api/admin/kiosks`;

export interface KioskDeviceStatus {
    phase: string;
    percent: number;
    lastSuccess: string | null;
    error: string;
    revision: string;
}

export interface KioskDevice {
    id: string;
    name: string;
    isActive: boolean;
    online: boolean;
    owner: { id: string; username: string; displayName: string };
    lastSeenAt: string | null;
    lastStartedAt: string | null;
    appVersion: string;
    platform: string;
    arch: string;
    salon: '' | 'showroom' | 'ufo';
    accountSignedIn: boolean;
    sync: KioskDeviceStatus;
    lastIp: string;
    createdAt: string | null;
    updatedAt: string | null;
}

export interface KioskAlertSettings {
    enabled: boolean;
    recipientEmail: string;
    limitUsedToday: boolean;
    lastAlertSentAt: string | null;
}

const list = async (): Promise<KioskDevice[]> => (await axios.get(BASE_URL)).data.devices;
const update = async (id: string, data: Partial<Pick<KioskDevice, 'name' | 'isActive'>>): Promise<KioskDevice> =>
    (await axios.patch(`${BASE_URL}/${id}`, data)).data.device;
const remove = async (id: string): Promise<void> => { await axios.delete(`${BASE_URL}/${id}`); };
const getAlertSettings = async (): Promise<KioskAlertSettings> => (await axios.get(`${BASE_URL}/alert-settings`)).data.settings;
const updateAlertSettings = async (data: Pick<KioskAlertSettings, 'enabled' | 'recipientEmail'>): Promise<KioskAlertSettings> =>
    (await axios.put(`${BASE_URL}/alert-settings`, data)).data.settings;
const resetAlertLimit = async (): Promise<KioskAlertSettings> => (await axios.post(`${BASE_URL}/alert-settings/reset`)).data.settings;

const kioskDevices = { list, update, remove, getAlertSettings, updateAlertSettings, resetAlertLimit };
export default kioskDevices;
